export const clientList = 'buyers';
export const startDate = 'fromDate';
export const endDate = 'toDate';
